module.exports = {
      id: "green-tick-usage",
      viewBox: "0 0 26 26",
      url: __webpack_public_path__ + "svg-sprite-c58a3b4628aec4c6d4a5f4fa9a2e0307.svg#green-tick",
      toString: function () {
        return this.url;
      }
    }